import ReactApexChart from 'react-apexcharts';
import {ApexOptions} from 'apexcharts';

export interface ChartBarProps {
    colors: string[];
    categories: unknown[];
    data: number[];
    showYaxis?: boolean;
    hiddenCategorieInLabel?: boolean;
    dataLabelsPosition?: string;
    dataLabelsTextAchor?: 'end' | 'start' | 'middle';
    height?: number;
}

const ChartBar = (props: ChartBarProps) => {

  const chartOptions: ApexOptions = {
    chart: {
      type: 'bar',
      height: props.height ? props.height : 350,
      toolbar: {show: false},
      fontFamily: 'inherit',
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        borderRadius: 8,
        horizontal: true,
        distributed: true,
        barHeight: 50,
        dataLabels: {
          position: props.dataLabelsPosition ? props.dataLabelsPosition : 'bottom',
        },
      }
    },
    colors: props.colors,
    dataLabels: {
      enabled: true,
      textAnchor: props.dataLabelsTextAchor,
      offsetX: 10,
      formatter: function (val, opt) {
        return props.hiddenCategorieInLabel ? '' + val : '\n\n\n' + opt.w.globals.labels[opt.dataPointIndex] + ':  ' + val
      },
      style: {
        fontSize: '14px',
        fontWeight: '500',
        colors: ['#fff']
      },
      dropShadow: {
        enabled: true
      }
    },
    grid: {
      borderColor: '#E4E6EF',
      xaxis: {lines: {show: true}},
      yaxis: {lines: {show: false}},
      strokeDashArray: 4,
    },
    tooltip: {
      style: {fontSize: '12px'},
      y: {formatter: (val: number) => `${val}`},
    },
    yaxis: {
      show: props.showYaxis, // Hides the Y-axis
    },
    xaxis: {
      categories: props.categories ?? [],
    },
  };

  const chartSeries = [
    {
      name: 'KPI',
      // ApexCharts crashes (`Cannot read properties of undefined (reading 'slice')`)
      // when the series data is undefined, which happens before the KPI data loads.
      data: props.data ?? [],
    },
  ]

  return (
    <ReactApexChart options={chartOptions} series={chartSeries} type="bar" height={props.height ? props.height : 350}/>
  );
};

export default ChartBar;
